import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Clock, X } from 'lucide-react';

const RECENT_KEY = 'rk_recent_visited';

export default function RecentlyVisitedBar({ onTabNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      setItems(stored.filter(i => i.path !== location.pathname).slice(0, 5));
    } catch { setItems([]); }
  }, [location.pathname]);

  if (items.length === 0) return null;

  const handleClick = (item) => {
    if (item.isTab && item.tabKey) {
      onTabNavigate?.(item.tabKey);
      navigate('/dashboard');
    } else {
      navigate(item.path);
    }
  };

  const removeItem = (e, path) => {
    e.stopPropagation();
    try {
      const stored = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      const updated = stored.filter(i => i.path !== path);
      localStorage.setItem(RECENT_KEY, JSON.stringify(updated));
      setItems(updated.filter(i => i.path !== location.pathname).slice(0, 5));
    } catch {}
  };

  return (
    <div className="mb-4 max-w-full overflow-hidden" data-testid="recently-visited-bar">
      <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide pb-1 pr-6 rk-scroll-fade" style={{ WebkitOverflowScrolling: 'touch' }}>
        <span className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-muted-foreground/60 whitespace-nowrap shrink-0">
          <Clock className="w-3 h-3" /> Recent
        </span>
        {items.map(item => (
          <button key={item.path} onClick={() => handleClick(item)}
            className="group inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-border/40 text-xs text-muted-foreground hover:text-foreground hover:border-[#B99A65]/40 transition-colors whitespace-nowrap shrink-0 rounded-sm"
            data-testid={`recent-chip-${item.label.replace(/\s+/g, '-').toLowerCase()}`}>
            <span>{item.label}</span>
            <span className="opacity-0 group-hover:opacity-100 transition-opacity" onClick={(e) => removeItem(e, item.path)}>
              <X className="w-3 h-3 text-muted-foreground hover:text-red-500" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
